import { render } from "./add-product.vue?vue&type=template&id=61379720"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__